module.exports = __webpack_public_path__ + "static/media/Bulldog Face 1c.ed9a054d.svg";